/**
 * This file will configure various resources for your application.
 * - Logging to New Relic (More configuration required - see below)
 * - Analytics tracking through Adobe Target Events
 * - Daxi (The Origin Digital http request library)
 *
 * Anything else required before your app is loaded can be included in this
 * file.
 */

import {
  configAnalytics,
  configNewRelic,
} from "@origin-digital/reporting-client";
import { configFetch, configFetchCache } from "@origin-digital/daxi";
import { config, appName } from "./config";

declare const __DEV__: boolean;

const envAppName = `${appName}-${config.env}`;

configAnalytics({
  appName,
  debugToConsole: config.analyticsDebugToConsole,
});

configNewRelic({
  logLevel: config.logLevelNewRelic,
  consoleLogLevel: config.logLevelConsole, // error level to send to new relic
  sendOnErrors: true,
  appName: envAppName,
  endpoint: "https://log-api.newrelic.com/log/v1",
  apiKey: config.newRelicCollectorKey,
  sourceEnv: config.env as EnvironmentNames,
});

/* eslint-disable-next-line no-undef */
configFetch({ disableAuthCheck: __DEV__ });
configFetchCache({ disableCache: __DEV__ });
